import $ from 'jquery';


export default class SlickSlider {
    init() {
        $('[data-slick]').not('.slick-initialized').each(function() {
            let self = $( this );
            if(self.data('count') === 1){
                return;
            }

            self.slick({
                prevArrow:"<button type=\"button\" class=\"btn btn-link slick-prev slick-arrow\"><svg width=\"9\" height=\"17\" viewBox=\"0 0 9 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                "<path d=\"M8.85355 1.35355C9.04882 1.15829 9.04882 0.841709 8.85355 0.646447C8.65829 0.451184 8.34171 0.451184 8.14645 0.646447L8.85355 1.35355ZM1 8.5L0.646446 8.14645L0.292893 8.5L0.646446 8.85355L1 8.5ZM8.14645 16.3536C8.34171 16.5488 8.65829 16.5488 8.85355 16.3536C9.04881 16.1583 9.04881 15.8417 8.85355 15.6464L8.14645 16.3536ZM8.14645 0.646447L0.646446 8.14645L1.35355 8.85355L8.85355 1.35355L8.14645 0.646447ZM0.646446 8.85355L8.14645 16.3536L8.85355 15.6464L1.35355 8.14645L0.646446 8.85355Z\" fill=\"#2D0007\"/>\n" +
                "</svg></button>",
                nextArrow:"<button type=\"button\" class=\"btn btn-link slick-next slick-arrow\"><svg width=\"10\" height=\"17\" viewBox=\"0 0 10 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                "<path d=\"M0.646447 15.6464C0.451184 15.8417 0.451184 16.1583 0.646447 16.3536C0.841709 16.5488 1.15829 16.5488 1.35355 16.3536L0.646447 15.6464ZM8.5 8.5L8.85355 8.85355L9.20711 8.5L8.85355 8.14645L8.5 8.5ZM1.35355 0.646447C1.15829 0.451184 0.841708 0.451184 0.646446 0.646447C0.451184 0.841709 0.451184 1.15829 0.646446 1.35355L1.35355 0.646447ZM1.35355 16.3536L8.85355 8.85355L8.14645 8.14645L0.646447 15.6464L1.35355 16.3536ZM8.85355 8.14645L1.35355 0.646447L0.646446 1.35355L8.14645 8.85355L8.85355 8.14645Z\" fill=\"#2D0007\"/>\n" +
                "</svg></button>"

                });
        });
    }

}
